// 判断不在对象中默认值 'No Data'
const noData = (obj, id, text) => {
  let Obj = { name: "", code: "" };
  if (obj.hasOwnProperty(id)) {
    if (text == "cityGroup") {
      Obj.name = obj[id].group_name;
    }
    if (text == "clientGroup") {
      Obj.name = obj[id].group_name;
    }
    if (text == "department") {
      Obj.name = obj[id];
    }
    if (text == "timezone") {
      Obj.name = obj[id].title;
    }
    if (text == "freight") {
      Obj.name = obj[id].title;
    }
    if (text == "warehouse") {
      Obj.name = obj[id].warehouse_code;
    }
    if (text == "trackerStatus") {
      Obj.name = obj[id].tracker_code;
    }
    if (text == "agentAccount") {
      Obj.name = obj[id].params_account;
    }
    if (text == "label") {
      Obj.name = obj[id].title;
    }
    if (text == "agent") {
      Obj.name = obj[id].agent_name;
    }
    if (text == "rolemap") {
      Obj.name = obj[id].standard_role;
    }
    if (text == "method") {
      Obj.name = obj[id].method_name;
    }
    if (text == "role") {
      Obj.name = obj[id].role_name;
    }
    if (text == "country") {
      Obj.code = obj[id].country_code;
    }
    if (text == "currency") {
      Obj.name = obj[id].unit;
    }
    if (text == "city") {
      Obj.name = obj[id].city_name;
      Obj.code = obj[id].city_code;
    }
    if (text == "client") {
      Obj.name = obj[id].shipper_account;
    }
    if (text == "account") {
      Obj.name = obj[id].shipper_account;
    }
    if (text == "user") {
      Obj.name = obj[id].account;
    }
    return Obj;
  }
  Obj = { name: "No Data", code: "No Data" };
  return Obj;
};
export default { noData };
